// Solid icons
import {
    faCalendar,
    faCalendarPlus,
    faEnvelope,
    faLocationDot,
    faPhone,
    faRepeat,
    faUser,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
    FaFacebook,
    FaInstagram,
    FaTwitter,
    FaLinkedinIn,
} from "react-icons/fa";
import { formatDate, getCountryCode, getMobileNumberByType, getValueOrPlaceHolder, maskContactNumber, navigateToCrmDetail } from "../../../Utils/helpers/commonhelper"
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import useLocalStorageState from "use-local-storage-state";
import { toast } from "sonner";
import { useGetEssentials } from "../../../Utils/hooks/useGetEssentials";
import { useLocation } from "react-router-dom";

export const PersonalDealDetails = ({ dealData }) => {
    const { navigate } = useGetEssentials()
    const location = useLocation()
    const [customer, setCustomer] = useLocalStorageState('customer')
    const [PERMISSION, _] = useLocalStorageState("permission");
    const [showAllPhoneNumbers, setShowAllPhoneNumbers] = useState(false);

    const companyViewPermission = PERMISSION.company?.isView;
    const contactViewPermission = PERMISSION.contact?.isView;

    const formatAddress = (data) => {
        if (!data) return "-";

        const addressParts = [
            data?.address?.trim(),
            data?.city_name?.trim(),
            data?.state_name?.trim(),
            data?.country_name?.trim()
        ].filter(part => part && part !== "" && part !== "-");

        return addressParts.length > 0 ? addressParts.join(", ") : "-";
    };
    const iconColor = "#2656a8"
    // Social icon helper for a cleaner look
    const renderSocialIcon = (title, icon, link, color) => {
        const hasLink = link && link !== "" && link !== "-";

        return (
            <div
                className="d-flex align-items-center gap-2"
                onClick={() => hasLink && window.open(link, "_blank")}
                style={{
                    cursor: hasLink ? "pointer" : "default",
                    opacity: hasLink ? 1 : 0.6
                }}
            >
                <span
                    style={{
                        color: color,
                        padding: "8px",
                        background: `${color}10`,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s",
                        minWidth: "34px"
                    }}
                    className={hasLink ? "social-link-hover" : ""}
                >
                    {icon}
                </span>
                <div className="overflow-hidden">
                    <p className="mb-0 " style={miniLabelStyle}>{title}</p>
                    <p
                        className="mb-0 fw-medium text-truncate"
                        style={{
                            fontSize: "12px",
                            color: hasLink ? "#1e293b" : "#cbd5e1"
                        }}
                    >
                        {hasLink ? "View Profile" : getValueOrPlaceHolder(null)}
                    </p>
                </div>
            </div>
        );
    };

    const renderSection = (title, items, handler) => {
        return (
            <div className={`px-4 py-4 ${title?.toLowerCase()?.split(" ")?.join("_") !== "contact_details" && "border-top"} `}>
                {/* Section Label */}
                <p className="mb-0 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>{title}</p>

                <Row className="g-3 mt-1">
                    {items.map((item, idx) => (
                        <Col
                            key={idx}
                            md={item.fullWidth ? 12 : 6}
                            className="d-flex align-items-start gap-3"
                        >
                            {/* The Icon inside a subtle tinted box */}
                            {item.icon && (
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-2"
                                    style={{
                                        backgroundColor: "#f1f5f9",
                                        minWidth: "32px",
                                        height: "32px",
                                        color: iconColor
                                    }}
                                >
                                    <FontAwesomeIcon icon={item.icon} size="sm" />
                                </div>
                            )}

                            <div className="overflow-hidden">
                                <span className="mb-0" style={{ ...miniLabelStyle }}>{item.label}</span>
                                <p
                                    className="mb-0 text-truncate"
                                    onClick={() => {
                                        if (!item.isLink) return
                                        handler()
                                    }}
                                    style={{
                                        fontSize: "13px",
                                        color: item.isLink ? "#0099ff" : "#1e293b",
                                        cursor: item.isLink ? "pointer" : "default",
                                        fontSize: item.isLink && "1rem",
                                        fontWeight: item.isLink && 500
                                    }}
                                >
                                    {getValueOrPlaceHolder(item.value)}
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div >
        );
    };

    const phone_type = dealData?.user_phone && JSON.parse(dealData?.user_phone)?.[0]?.phone_type
    const contactPhoneData = dealData?.user_phone && JSON.parse(dealData?.user_phone)
    const phoneEntries = Array.isArray(contactPhoneData) ? contactPhoneData : []
    const visiblePhoneEntries = showAllPhoneNumbers ? phoneEntries : phoneEntries.slice(0, 1)
    const hasMorePhones = phoneEntries.length > 1

    const contactLabels = [
        { label: "Contact Name", value: dealData?.contact_name, isLink: true, type: 'name', },
        { label: "Phone", value: `${getMobileNumberByType(customer, dealData?.user_phone, phone_type)}`, icon: faPhone },
        { label: "Personal Phone", value: contactPhoneData?.map(c => `${getCountryCode(dealData)} ${maskContactNumber(customer, c.phone, c.phone_type)},`), icon: faPhone },
        { label: "Email", value: dealData?.email, icon: faEnvelope, fullWidth: false },
        { label: "Address", value: dealData?.contact_address, icon: faLocationDot },
    ]

    return (
        <>
            <div
                className="info-sidebar"
                style={{
                    width: "50%",
                    background: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.02)",
                    height: "100%",
                    overflow: "hidden"
                }}
            >

                <div className={`px-4 py-4`}>
                    {/* Section Label */}
                    <p className="mb-0 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>Contact Details</p>

                    <Row className="g-3 mt-1">
                        {contactLabels.map((item, idx) => {
                            const lowerCaseLabel = item.label?.toLowerCase()?.split(" ")?.join("_")
                            return <Col
                                key={idx}
                                md={item.fullWidth ? 12 : 6}
                                className="d-flex align-items-start gap-3"
                            >
                                {/* The Icon inside a subtle tinted box */}
                                {item.icon && (
                                    <div
                                        className="d-flex align-items-center justify-content-center rounded-2"
                                        style={{
                                            backgroundColor: "#f1f5f9",
                                            minWidth: "32px",
                                            height: "32px",
                                            color: iconColor
                                        }}
                                    >
                                        <FontAwesomeIcon icon={item.icon} size="sm" />
                                    </div>
                                )}

                                <div className="overflow-hidden w-100">
                                    <span className="mb-0" style={{ ...miniLabelStyle }}>{item.label}</span>
                                    {lowerCaseLabel === "personal_phone" ? (
                                        <div className="w-100" style={{ fontSize: "12px", color: "#1e293b", letterSpacing: "0.25px" }}>
                                            {visiblePhoneEntries.length > 0 ? (
                                                visiblePhoneEntries.map((phoneItem, idx) => (
                                                    <div
                                                        key={`${phoneItem.phone_type}-${phoneItem.phone}-${idx}`}
                                                        className="mb-1"
                                                        title={`${phoneItem.phone_type} ${getCountryCode(dealData)} ${maskContactNumber(customer, phoneItem.phone, phoneItem.phone_type)}`}
                                                    >
                                                        <span style={{ textTransform: "capitalize" }}>
                                                            {phoneItem.phone_type || "Phone"}
                                                        </span>
                                                        : {getCountryCode(dealData)} {maskContactNumber(customer, phoneItem.phone, phoneItem.phone_type)}
                                                    </div>
                                                ))
                                            ) : (
                                                <span className="text-muted">{getValueOrPlaceHolder(item.value)}</span>
                                            )}

                                            {hasMorePhones && !showAllPhoneNumbers && (
                                                <span
                                                    className="d-inline-block mt-1"
                                                    style={{ color: "#0d6efd", cursor: "pointer", fontSize: "13px" }}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        setShowAllPhoneNumbers(true)
                                                    }}
                                                >
                                                    +{phoneEntries.length - 1} more
                                                </span>
                                            )}

                                            {showAllPhoneNumbers && hasMorePhones && (
                                                <span
                                                    className="d-inline-block mt-1"
                                                    style={{ color: "#0d6efd", cursor: "pointer", fontSize: "13px" }}
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        setShowAllPhoneNumbers(false)
                                                    }}
                                                >
                                                    Show less
                                                </span>
                                            )}
                                        </div>
                                    ) : (
                                        <p
                                            className={`mb-0 text-truncate`}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                if (lowerCaseLabel === "contact_name") {
                                                    if (!contactViewPermission) {
                                                        toast.warning("You are not authorized for this action!")
                                                        return
                                                    }
                                                    navigateToCrmDetail(
                                                        navigate,
                                                        location,
                                                        `/contactDetails?currContactId=${dealData.contact_id}`,
                                                    )
                                                }
                                                return
                                            }}
                                            style={{
                                                color: lowerCaseLabel === "contact_name" && "#0099ff",
                                                cursor: lowerCaseLabel === "contact_name" && "pointer",
                                                fontSize: lowerCaseLabel === "contact_name" ? "0.833rem" : '12px',
                                                fontWeight: lowerCaseLabel === "contact_name" && 500,
                                                textTransform: lowerCaseLabel === "contact_name" && "capitalize",
                                                textWrap: lowerCaseLabel === "phone" && "nowrap",
                                                letterSpacing: "0.25px",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word"
                                            }}
                                        >
                                            {getValueOrPlaceHolder(item.value)}
                                        </p>
                                    )}
                                </div>
                            </Col>
                        })}
                    </Row>
                </div >

                {/* Company Details */}
                <div className="px-4 py-3 border-top" >
                    <p className="mb-0 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>Company Details</p>
                    <div className="mt-2 mb-3">
                        <p
                            onClick={() => {
                                if (!companyViewPermission) {
                                    toast.warning("You are not authorized for this action!")
                                    return
                                }
                                navigateToCrmDetail(
                                    navigate,
                                    location,
                                    `/companyDetails?currCompanyId=${dealData?.company_id}`,
                                )
                            }}
                            className="mb-0 " style={{ color: "#0099ff", fontSize: "0.8333rem", textTransform: "capitalize", fontWeight: 500, cursor: "pointer" }}>
                            {getValueOrPlaceHolder(dealData?.company_name, "Unmapped Company")}
                        </p>
                        <div className="d-flex align-items-center gap-1 text-muted" style={{ fontSize: "12px" }}>
                            <i className="bi bi-geo-alt"></i>
                            {getValueOrPlaceHolder(dealData?.company_address, "No company address")}
                        </div>
                    </div>
                    <Row className="g-3">
                        <Col md={6}>
                            <span style={miniLabelStyle}>Type</span>
                            <p className="mb-0 fw-medium fs-13">{getValueOrPlaceHolder(dealData?.business_type)}</p>
                        </Col>
                        <Col md={6}>
                            <span style={miniLabelStyle}>Owner</span>
                            <p className="mb-0 fw-medium fs-13">{getValueOrPlaceHolder(dealData?.company_owner_name)}</p>
                        </Col>
                        <Col md={6}>
                            <span style={miniLabelStyle}>Company Email</span>
                            <p className="mb-0 fw-medium fs-13 text-break">{getValueOrPlaceHolder(dealData?.company_email)}</p>
                        </Col>
                        <Col
                            md={6}
                            className="mb-0 d-flex align-items-center"
                        >
                            <div>
                                <p className="mb-0" >
                                    Phone
                                </p>
                                <p className="mb-0" style={{ letterSpacing: "0.25px" }} >
                                    {
                                        dealData?.company_phone ?
                                            JSON.parse(dealData?.company_phone)?.[0]?.phone ?
                                                `${JSON.parse(dealData?.company_phone)?.[0]?.country_code} ${maskContactNumber(customer, JSON.parse(dealData?.company_phone)?.[0]?.phone, dealData?.phone_type)}`
                                                :
                                                <p style={{ display: "inline-block", fontSize: "13px", color: "#afafaf" }}>No Data</p>
                                            :
                                            <p style={{ display: "inline-block", fontSize: "13px", color: "#afafaf" }}>No Data</p>
                                    }
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Internal Details */}
                {renderSection("System Internal", [
                    { label: "Created By", value: dealData?.lead_added_name, icon: faUserPlus },
                    { label: "Source", value: dealData?.source_title, icon: faRepeat },
                    { label: "Created Date", value: formatDate(dealData?.created_at), icon: faCalendarPlus },
                    { label: "Updated Date", value: formatDate(dealData?.updated_at), icon: faCalendar },
                    { label: "Updated By", value: dealData?.lead_updated_name, icon: faUser },
                    { label: "Lead Owner", value: dealData?.deal_owner_name, icon: faUser },
                ], true)}

                {/* Social Profiles */}
                <div className="px-4 py-3 border-top">
                    <p className="mb-3 " style={{ fontSize: "1.2rem", letterSpacing: "0.3px", fontWeight: 300 }}>Social Details</p>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "16px"
                        }}
                    >
                        {renderSocialIcon("Facebook", <FaFacebook />, dealData?.facebook, "#1877F2")}
                        {renderSocialIcon("Instagram", <FaInstagram />, dealData?.instagram, "#E4405F")}
                        {renderSocialIcon("Twitter", <FaTwitter />, dealData?.twitter, "#1DA1F2")}
                        {renderSocialIcon("Linkedin", <FaLinkedinIn />, dealData?.linkedin, "#0A66C2")}
                    </div>
                </div>

                <style jsx>{`
                    .social-link-hover : hover {
                        transform: translateY(-2px);
                        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
                        filter: brightness(0.95);
                    }
                    .social-link-hover:hover {
                        transform: translateY(-2px);
                        filter: brightness(0.9);
                    }

                    .info-sidebar p {
                        line-height: 1.4;
                    }

                    .info-sidebar label {
                        user-select: none;
                    }
                `}</style>
            </div>
        </>
    )
}


const miniLabelStyle = {
    fontSize: "12px",
    fontWeight: "400",
    color: "#94a3b8",
    display: "block",
    marginBottom: "2px"
};